import { useEffect, useState } from 'react';
import { Check2, Copy } from 'react-bootstrap-icons';
import { CopyToClipboard as ReactCopyToClipboard } from 'react-copy-to-clipboard';
import { useTranslation } from 'react-i18next';

/**
 * @param {string} text
 * @param {string} tooltip
 * @param {number} iconSize
 */
export function CopyToClipboard({ text, tooltip = 'global:btn.copyToClipboard', iconSize = 12 }) {
    const [copied, setCopied] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        if (copied === true) {
            // Hide complete message after 2 seconds
            setTimeout(() => {
                setCopied(false);
            }, 2000);
        }
    }, [copied]);

    return (
        <ReactCopyToClipboard text={text} onCopy={() => setCopied(true)}>
            {copied ? (
                <Check2
                    className="text-success flex-shrink-0"
                    data-uk-tooltip={t('global:btn.copied')}
                    size={iconSize}
                />
            ) : (
                <Copy
                    onClick={(e) => e.stopPropagation()}
                    className="cursor-pointer flex-shrink-0"
                    data-uk-tooltip={t(tooltip)}
                    size={iconSize}
                />
            )}
        </ReactCopyToClipboard>
    );
}
